module.exports = __webpack_public_path__ + "img/mobDeleteIcon.b2843be4.svg";